export default __webpack_public_path__ + "fonts/Roboto-300-cyrillic-ext1.woff2";